import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { FilterAction } from './FilterAction';
import { ButtonProps } from './types';

const { Icon } = elements;

export function DeleteAction(props: ButtonProps) {
  return (
    <FilterAction label="Delete" {...props}>
      <Icon.icons.Delete />
    </FilterAction>
  );
}
